<template>
  <span class="coming-soon">{{ $t('coming.soon') }}</span>
</template>

<script>
export default {
  name: 'ComingSoon',
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.coming-soon {
  display: inline-block;
  color: $coming-soon;
  text-align: center;
  border: solid $border-width-thin $coming-soon;
  padding: rem(2);
  border-radius: $radius-sm;
}
</style>
